<form-control
  direction="grouping"
  [config]="config"
  [control]="formGroup.get(config.prop)"
  data-test-id="citiesFormControl"
>
</form-control>
